import {
    IParcelas,
    IParcelasResponse,
    IParcelaBoletos,
    IBoletoPDF,
    IDadosFinanceirosRequest,
    IDadosFinanceirosReceber,
    IDadosFinanceirosRecebidosResponse,
} from "../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import { IListaParcelasSerasa } from "../../../Interfaces/Geral/InformacoesVenda/InformacoesVendaInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarParcelasAbertasUAU(requestBody: IParcelas) {
    return Service(
        Axios.post<Array<IParcelasResponse>>(
            `/cobranca/parcelas/consultarparcelasemabertouau`,
            requestBody
        )
    );
}

export async function BuscarParcelasAReceberServices(requestBody: IParcelas) {
    return Service(
        Axios.post<Array<IParcelasResponse>>(
            `/cobranca/parcelas/buscarparcelasareceberuau`,
            requestBody
        )
    );
}

export async function ListarParcelasBoletosService(requestBody: IParcelas) {
    return Service(
        Axios.post<Array<IParcelaBoletos>>(
            `/cobranca/parcelas/consultarparcelasboletos`,
            requestBody
        )
    );
}

export async function GetBoletoPDFService(requestBody: IBoletoPDF) {
    return Service(
        Axios.post<string>(`/cobranca/boleto/baixarboletopdf`, requestBody)
    );
}

export async function BaixarBoletoPDFESolutionService(
    NR_CPF: string,
    requestBody: Array<string>
) {
    return Service(
        Axios.post<string>(
            `/cobranca/boleto/BaixarBoletoPDFESolution?NR_CPF=${NR_CPF}`,
            requestBody
        )
    );
}

export async function GerarPdfESolutionService(
    NR_CPF: string,
    requestBody: Array<string>
) {
    return Service(
        Axios.post<string>(
            `/cobranca/parcelas/gerarpdfesolution?NR_CPF=${NR_CPF}`,
            requestBody
        )
    );
}

export async function ListarParcelasAbertasDadosFinanceirosService(
    requestBody: IDadosFinanceirosRequest,
    antecipacao: boolean
) {
    return Service(
        Axios.post<Array<IDadosFinanceirosReceber>>(
            `/cobranca/parcelas/listarparcelasabertasdadosfinanceiros?antecipacao=${antecipacao}`,
            requestBody
        )
    );
}
export async function ListarParcelasRecebidasDadosFinanceirosService(
    ID_CHAVE_ERP: string
) {
    return Service(
        Axios.post<IDadosFinanceirosRecebidosResponse>(
            `/cobranca/parcelas/listarparcelasrecebidasdadosfinanceiros?ID_CHAVE_ERP=${ID_CHAVE_ERP}`
        )
    );
}

export async function ListarParcelasSerasaService(idChaveERP: string) {
    return Service(
        Axios.get<Array<IListaParcelasSerasa>>(
            `/cobranca/renegociacao/listaparcelasserasa?idChaveERP=${idChaveERP}`
        )
    );
}
